import { render } from "./NotFound.vue?vue&type=template&id=089fc56c"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=089fc56c&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__